<template>
  <div class="index">
    <van-nav-bar title="登记新卡号" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <div v-if="status == 1 ">
      <van-form @submit="onSubmit" class="form">
        <van-field
          v-model="carForm.oldCarNum"
          name="原卡号"
          label="原卡号："
          placeholder="原卡号"
          disabled
        />
        <van-field
          v-model="carForm.newCarNum"
          name="新卡号"
          label="新卡号："
          placeholder="请输入新卡号"
          :rules="[{ required: true, message: '请填写新卡号' }]"
        />
        <div style="margin: 2rem 16px 1rem">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <div class="succeed" v-else>
      <van-icon name="checked" size="3rem" color="#4FB640"/>
      <div class="text">新卡号登记成功</div>
      <van-button style="margin-top:2rem;width:7rem;" round type="info" @click="toPath">返回首页</van-button>

    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        status: 1,
        openId: '',
        carForm: {
          oldCarNum: '',
          newCarNum: '',
        }
      }
    },
    created () {
      this.carForm.oldCarNum = this.$route.query.cardNumber
      this.openId = this.$route.query.openId
    },
    mounted () {

    },
    methods: {
      // 提交换卡申请
      onSubmit () {
        let data = {
          openId: this.openId,
          oldCardNumber: this.carForm.oldCarNum,
          newCardNumber: this.carForm.newCarNum,
        }
        this.$axios.post('/lockapi/smartlock/input-newcardnumber', data).then(res => {
          if (res.data.success) {
            this.status = 2
          } else {
            this.$toast.fail('提交失败,原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('提交失败!')
        })

      },
      // 返回首页
      toPath () {
        location.href = '/#/intelligentLock/portal'
      },
      //   后退
      onClickLeft () {
        location.href = '/#/intelligentLock/portal'
      }

    },
  }
</script>
<style lang="less" scoped>
  .index {
    .form {
      padding-top: 1rem;
      background-color: #fff;

      .van-field {
        font-size: 0.6rem;
      }
    }

    .succeed {
      padding-top: 4rem;

      .text {
        margin-top: 1rem;
        text-align: center;
        font-size: 0.7rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/intelligentLock/carchangeApplyfor.vue